module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 4.fbdd4e81.png";